module.exports = __webpack_public_path__ + "img/arsalan sartaj.d71c2338.jpg";